import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';
import { RootState } from '@lib/redux.lib/store';
import { JobsBoardModalFilters } from '@views/jobsBoard/context';

import {
  buildPayloadSearchFilters,
  JOBS_BOARD_POSTS_PRIVATE_QUERY_KEY,
} from '../utils';

export const useGetJobsBoardPosts = (
  jobsBoardSearchFilters: JobsBoardModalFilters
) => {
  const userId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [
      JOBS_BOARD_POSTS_PRIVATE_QUERY_KEY,
      jobsBoardSearchFilters,
      userId,
    ],
    queryFn: () => {
      const payload = buildPayloadSearchFilters(jobsBoardSearchFilters);
      return PublicApplicationAPI.getJobsBoardPosts(payload, userId);
    },
    enabled: !!userId,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};
